import React from 'react';
import './TextArea.module.scss';

type Props = {
  value: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export default function TextArea({ value, placeholder = '', onChange }: Props) {
  return (
    <div styleName="TextArea">
      <textarea onChange={onChange} placeholder={placeholder} value={value} />
    </div>
  );
}
